/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jolly_Left_Wolf_TrustInputs */

const en_jolly_left_wolf_trust = /** @type {(inputs: Jolly_Left_Wolf_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Area`)
};

const de_jolly_left_wolf_trust = /** @type {(inputs: Jolly_Left_Wolf_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Bereich`)
};

/**
* | output |
* | --- |
* | "My Area" |
*
* @param {Jolly_Left_Wolf_TrustInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jolly_left_wolf_trust = /** @type {((inputs?: Jolly_Left_Wolf_TrustInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jolly_Left_Wolf_TrustInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jolly_left_wolf_trust(inputs)
	return de_jolly_left_wolf_trust(inputs)
});